import { useCallback } from 'react'
import { useCreatePatientMatch } from '../api'
import type { PatientMatch } from './types'
import { useSubmitPatientMatchingReview } from './use-submit-patient-matching-review'

export function useCreatePatientMatchAndValidate({ documentKey }: { documentKey: string }) {
  const { mutateAsync: createPatientMatch } = useCreatePatientMatch()
  const { submitPatientMatchingReview } = useSubmitPatientMatchingReview({ documentKey })

  const createPatientMatchAndValidate = useCallback(
    async (patientMatch: PatientMatch) => {
      const patientRecord = await createPatientMatch({
        path: { key: documentKey },
        body: patientMatch,
      })
      if (
        patientRecord.success &&
        patientRecord.index !== undefined &&
        patientRecord.index !== null
      ) {
        await submitPatientMatchingReview({
          match_status: 'validated',
          selected_match_index: patientRecord.index,
        })
      } else {
        throw new Error(`Failed to create patient match: ${patientRecord.message}`)
      }
    },
    [createPatientMatch, documentKey, submitPatientMatchingReview],
  )

  return {
    createPatientMatchAndValidate,
  }
}
